import { Outlet } from "react-router-dom";
import HeroSection from "components/hero-section/HeroSection";
import TermBanner from "components/term-banner/TermBanner";
import ReadyBanner from "components/ready-banner/ReadyBanner";
import TrustPilotScore from "components/trust-pilot-score/TrustPilotScore";
import TrustPilotCarousel from "components/trust-pilot-carousel/TrustPilotCarousel";
import {
    DirectTermLifeInsurance,
    DisclosuresDto,
    DisclosuresMlta,
    FinancialRealities,
    HowItWorks,
    ValueProps,
    WhyNow,
    AccidentsAreCommonAndCostly,
    ThreeEasySteps,
    MorePeaceOfMind,
    HowAccidentInsuranceWorks,
} from "components/marketing";
import { useProductContext } from "context/ProductContext";

/**
 * Landing Page Layout Component
 * Provides the shared layout wrapper for invitation and quote pages
 * Renders marketing content with an <Outlet /> for nested route content
 */
const LandingPageLayout = () => {
    const { isMLTA } = useProductContext();
    return (
        <div className="flex flex-col w-full overflow-x-clip">
            <HeroSection
                bannerContent={
                    <div
                        className="w-full h-full flex flex-col justify-between tablet:gap-[262px] pl-4 pr-4 tablet:pl-0 tablet:pr-0"
                        id="term-banner-content"
                    >
                        <TrustPilotScore />
                        <TermBanner />
                    </div>
                }
                cardContent={
                    <div id="hero-card" className="w-full h-full flex flex-col justify-center items-center">
                        <Outlet />
                    </div>
                }
            />
            <ValueProps />
            {isMLTA ? (
                <>
                    <AccidentsAreCommonAndCostly />
                    <ThreeEasySteps />
                    <HowAccidentInsuranceWorks />
                    <MorePeaceOfMind />
                    <TrustPilotCarousel />
                    <DisclosuresMlta />
                </>
            ) : (
                <>
                    <WhyNow />
                    <HowItWorks />
                    <FinancialRealities />
                    <DirectTermLifeInsurance />
                    <TrustPilotCarousel />
                    <ReadyBanner />
                    <DisclosuresDto />
                </>
            )}
        </div>
    );
};

export default LandingPageLayout;
